import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import * as AppPropTypes from '../../lib/PropTypes';

import PillButton from '../buttons/Pill';

import styles from '../../../styles/partials/editions-dots.module.scss';

const propTypes = {
    edition: AppPropTypes.edition,
    editions: PropTypes.arrayOf(AppPropTypes.edition),
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    edition: null,
    editions: null,
    onClick: null,
    disabled: false,
    className: null,
};

const EditionsDots = ({ edition: currentEdition, editions, onClick, disabled, className }) => (
    <div
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
            },
        ])}
    >
        {(editions || []).map((edition, idx) => {
            const { handle: currentHandle = null } = currentEdition || {};
            const { handle = null } = edition || {};
            return handle !== null ? (
                <PillButton
                    className={classNames([styles.item])}
                    onClick={() => onClick(edition)}
                    active={currentHandle !== null && currentHandle === handle}
                    disabled={disabled}
                    key={`${handle}-${idx + 1}`}
                >
                    <span className={styles.label}>
                        <FormattedMessage defaultMessage="Edition" description="Edition label" />
                    </span>
                    {handle}
                </PillButton>
            ) : null;
        })}
    </div>
);

EditionsDots.propTypes = propTypes;
EditionsDots.defaultProps = defaultProps;

export default EditionsDots;
